import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
  
    code:0
    
}
const mutations={
   
  
    getStatisticalInfo(state,value){
        
        
       
        post(urls.admin.statistical.info,value).then((result)=>{
          
          
          
          state.result=result
        
       
        
       
           
        });
        
    },
  
    
   

    

}
const  actions={
    getStatisticalInfoAction(context,value){
       
        context.commit("getStatisticalInfo",value)
       
    },
  
  
    
   

}

export default {state,mutations,actions}